import { createSlice } from "@reduxjs/toolkit"

const permissionSlice = createSlice({
  name: "permissions",
  initialState: {
    permissionList: [],
    permissionLoading: false,
    refetchData: false,
  },
  reducers: {
    getPermissions(state) {
      return {
        ...state,
        applicationLoading: true,
      }
    },
    getPermissionsSuccess(state, { payload }) {
      return {
        ...state,
        permissionList: payload.data.permissions || [],
        total:
          payload.data.total && payload.data.total.value
            ? payload.data.total.value
            : payload.data.total
            ? payload.data.total
            : 0,
        permissionLoading: false,
      }
    },
    upsertPermission(state) {
      return {
        ...state,
        loading: true,
        refetchData: false,
      }
    },
    upsertPermissionSuccess(state) {
      return {
        ...state.permissionDetails,
        loading: false,
        refetchData: true,
      }
    },
    getPermissionsByRoleCode(state) {
      return {
        ...state,
        applicationLoading: true,
      }
    },
    getPermissionsByRoleCodeSuccess(state, action) {
      return {
        ...state,
        permissionList: action.payload.data,
        permissionLoading: false,
      }
    },
    deletePermission(state) {
      return {
        ...state,
        permissionLoading: true,
        refetchData: false,
      }
    },
    deletePermissionSuccess(state) {
      return {
        ...state,
        permissionLoading: false,
        refetchData: true,
      }
    },
    resetState() {
      return {
        permissionList: [],
        permissionLoading: false,
        refetchData: false,
      }
    },
  },
})

export const {
  getPermissions,
  getPermissionsSuccess,
  getPermissionsByRoleCode,
  getPermissionsByRoleCodeSuccess,
  upsertPermission,
  upsertPermissionSuccess,
  deletePermission,
  deletePermissionSuccess,
  resetState,
} = permissionSlice.actions

export default permissionSlice.reducer
